import { after } from 'aspect-ts';
import { logUser, send_messages } from 'logger';
import { do_logout, xapi_logout } from '../widgets/logout';
const idleResets = ['onmousemove', 'onkeydown', 'onclick', 'onscroll'];
export class IdleMonitor {
    idle;
    idlefor;
    idletimer = null;
    logouttimer = null;
    _idletime;
    _idlelogout;
    constructor() {
        this.idle = false;
        this.idlefor = 0;
        this._idletime = 120000;
        this._idlelogout = 600000;
        for (const reset of idleResets) {
            if (document[reset] === null) {
                document[reset] = () => this.onReset();
            }
            else {
                after(document, reset, () => {
                    this.onReset();
                });
            }
        }
    }
    get idletime() {
        return this._idletime / 1000;
    }
    set idletime(value) {
        this._idletime = value * 1000;
    }
    get idlelogout() {
        return this._idlelogout / 1000;
    }
    set idlelogout(value) {
        this._idlelogout = value * 1000;
    }
    onReset() {
        if (this.idle) {
            this.idle = false;
            logUser.info(() => 'active');
            this.logouttimer && clearTimeout(this.logouttimer);
            this.idletimer = setTimeout(() => this.setIdle(), this._idletime);
            this.logouttimer = setTimeout(() => this.doLogout(), this._idlelogout);
        }
        else {
            this.idletimer && clearTimeout(this.idletimer);
            this.logouttimer && clearTimeout(this.logouttimer);
            this.idletimer = setTimeout(() => this.setIdle(), this._idletime);
            this.logouttimer = setTimeout(() => this.doLogout(), this._idlelogout);
        }
    }
    setIdle() {
        this.idle = true;
        logUser.info(() => `idle`);
    }
    doLogout() {
        logUser.info(() => `idle for at least ${this.idlelogout} seconds -- logging out`);
        xapi_logout();
        send_messages().then(() => do_logout(), () => do_logout());
    }
}
